





















































// Libraries
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class NavigationDrawer extends Vue {
  @Prop() readonly drawer!: { state: null | boolean }
}
